import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataRetention = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.464 5.896c0 .943 0 1.415.293 1.708s.765.292 1.707.292h11.071c.943 0 1.415 0 1.707-.292.293-.293.293-.765.293-1.708V4.5c0-.943 0-1.415-.293-1.708s-.764-.292-1.707-.292H4.465c-.943 0-1.415 0-1.708.292-.293.293-.293.765-.293 1.708zm12.262.243a.941.941 0 1 0 0-1.882.941.941 0 0 0 0 1.882m-1.767-.941a.941.941 0 1 1-1.882 0 .941.941 0 0 1 1.882 0m3.877 8.446a1 1 0 0 0-1.414 0l-.42.419v-3.738a1 1 0 0 0-2 0v3.738l-.418-.42a1 1 0 0 0-1.415 1.415l2.833 2.833 2.834-2.833a1 1 0 0 0 0-1.414m-13.664 0a1 1 0 0 1 1.414 0l.42.419V10.31a1 1 0 0 1 2 0v3.752l.418-.42a1 1 0 0 1 1.415 1.415L6.005 17.89l-2.833-2.833a1 1 0 0 1 0-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataRetention;
